import React from 'react';

export const Table = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <div className="overflow-x-auto">
    <table
      ref={ref}
      className={`w-full text-sm border-collapse ${className}`}
      {...props}
    >
      {children}
    </table>
  </div>
));

Table.displayName = 'Table';

export const TableHeader = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <thead ref={ref} className={`bg-gray-50 border-b border-gray-200 ${className}`} {...props}>
    {children}
  </thead>
));

TableHeader.displayName = 'TableHeader';

export const TableBody = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <tbody ref={ref} className={className} {...props}>
    {children}
  </tbody>
));

TableBody.displayName = 'TableBody';

export const TableRow = React.forwardRef(
  ({ className = '', children, ...props }, ref) => (
    <tr
      ref={ref}
      className={`border-b border-gray-200 hover:bg-gray-50 ${className}`}
      {...props}
    >
      {children}
    </tr>
  )
);

TableRow.displayName = 'TableRow';

export const TableHead = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <th
    ref={ref}
    className={`px-6 py-3 text-left font-semibold text-gray-900 ${className}`}
    {...props}
  >
    {children}
  </th>
));

TableHead.displayName = 'TableHead';

export const TableCell = React.forwardRef(({ className = '', children, ...props }, ref) => (
  <td
    ref={ref}
    className={`px-6 py-3 text-gray-700 ${className}`}
    {...props}
  >
    {children}
  </td>
));

TableCell.displayName = 'TableCell';
